import type { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    lenderAccount: {
      inputType: 'text',
      title: 'Lender Account',
      required: true,
      value: '',
      error: '',
    },
    lenderName: {
      inputType: 'text',
      title: 'Lender Name',
      required: true,
      value: '',
      error: '',
      readOnly: true,
    },
    pctOwned: {
      inputType: 'text',
      type: 'number',
      title: 'Pct Owned (%)',
      required: true,
      value: '',
      error: '',
    },
    lenderRate: {
      inputType: 'text',
      type: 'number',
      title: 'Lender Rate (%)',
      required: true,
      value: '',
      error: '',
    },
    principalBalance: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Principal Balance',
      required: true,
      value: '',
      error: '',
      prefix: '$',
    },
    regularPayment: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Regular Payment',
      required: true,
      value: '',
      error: '',
      prefix: '$',
    },
    roundingError: {
      inputType: 'toggle',
      title: 'Rounding Error',
      required: false,
      value: false,
      error: '',
    },
    notes: {
      inputType: 'textarea',
      title: 'Notes',
      required: false,
      value: '',
      error: '',
    },
  }
}
